import { PlayerProperty, Restore, Save } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from 'State/Player/IPlayerState';
import { FilteredKeys } from 'Utility/Types';
import { restoreStringifiedObject } from 'Player/ParseHelper';

type Value = NonNullable<{ [key: string]: unknown }>;

export default class ObjectProperty<
    TPlayerStateKey extends FilteredKeys<IPlayerState, Value>,
    TPlayerDataKey extends FilteredKeys<IPlayerData, string>
> implements PlayerProperty<TPlayerStateKey, TPlayerDataKey> {
    private readonly playerStateKey: TPlayerStateKey;
    private readonly playerDataKey: TPlayerDataKey;
    private readonly defaultValue: Value;

    constructor(playerStateKey: TPlayerStateKey, playerDataKey: TPlayerDataKey, defaultValue: Value) {
        this.playerStateKey = playerStateKey;
        this.playerDataKey = playerDataKey;
        this.defaultValue = defaultValue;
    }

    public isChanged(playerStateData: IPlayerState, playerEndpointData: IPlayerData): boolean {
        return playerEndpointData[this.playerDataKey] !== this.save(playerStateData)[this.playerDataKey];
    }

    public restore(playerEndpointData: IPlayerData): Restore<TPlayerStateKey> {
        // @ts-ignore
        return restoreStringifiedObject(playerEndpointData[this.playerDataKey], this.defaultValue);
    }

    public save(playerStateData: IPlayerState): Save<TPlayerDataKey> {
        const stringifiedData = JSON.stringify(playerStateData[this.playerStateKey] ?? this.defaultValue);
        return { [this.playerDataKey]:  stringifiedData} as any;
    }
}
